/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Vehicle_Road_Conditions_DescriptionInputs */

const en_case_section_vehicle_road_conditions_description = /** @type {(inputs: Case_Section_Vehicle_Road_Conditions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The vehicle that suffered the damage.`)
};

const pt_br2_case_section_vehicle_road_conditions_description = /** @type {(inputs: Case_Section_Vehicle_Road_Conditions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O veículo que sofreu o dano.`)
};

/**
* | output |
* | --- |
* | "The vehicle that suffered the damage." |
*
* @param {Case_Section_Vehicle_Road_Conditions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_vehicle_road_conditions_description = /** @type {((inputs?: Case_Section_Vehicle_Road_Conditions_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Vehicle_Road_Conditions_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_vehicle_road_conditions_description(inputs)
	return pt_br2_case_section_vehicle_road_conditions_description(inputs)
});